module.exports = __webpack_public_path__ + "static/website_home_howitworks_TA-f15fa723fcacf3842e9ea4b9c068b651.svg";